const DATE_FORMAT = {
  DATE: "yyyy-MM-dd",
  DATE_ONLY: "yyyy-MM-dd",
  DATE_WITH_TIME_S: "yyyy-MM-dd HH:mm:ss",
  DATE_WITH_TIME_M: "yyyy-MM-dd HH:mm",
  DATE_YYYYMMDD: "yyyyMMdd",
  DATE_MM_DD_YYYY: "MM/dd/yyyy",
  DATE_MM_DD_YYYY_WITH_TIME_S: "MM/dd/yyyy HH:mm:ss",
  DATE_MM_DD_YYYY_WITH_TIME_M: "MM/dd/yyyy HH:mm",
  DATE_MM_DD_YYYY_WITH_TIME_M_AM: "MM/dd/yyyy hh:mm a",
  TIME_M_AM: "hh:mm a",
};

export default DATE_FORMAT;
